import { getPromotionsComponents } from './getPromotionComponents';

export const promotionsService = {
  getPromotionsComponents,
};
